import React from "react";

function Footer() {
  return (
    <div className="flex justify-center items-end bg-primary text-smtext pt-12 font-bold">
      DEVELOPED while eating 🍕 with ❤
    </div>
  );
}

export default Footer;
